const namespaced = true

const state = {
  inventorySettings: {}
}

const mutations = {
  setOverrideInventorySettings (state, data) {
    state.inventorySettings = data.inventorySettings
  }
}

const getters = {
  getOverrideInventorySettings: (state) => {
    return state
  }
}

export default {
  namespaced,
  state,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/vuex/modules/general/overrideInventorySettings.js